export enum SignatureStatusEnum {
	STATUT_EN_COURS = 'STATUT_EN_COURS',
	STATUT_EXPIRE = 'STATUT_EXPIRE',
	STATUT_ANNULE = 'STATUT_ANNULE',
	STATUT_ERREUR = 'STATUT_ERREUR',
	STATUT_OK = 'STATUT_OK'
}
